import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteCadastroModule } from '../cadastro';
import { ClienteSituacaoModule } from '../situacao';

import { ClienteFormTextComponent } from './cliente-form-text.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteCadastroModule,
        ClienteSituacaoModule
    ],
    declarations: [
        ClienteFormTextComponent
    ],
    exports: [
        ClienteFormTextComponent
    ]
})
export class ClienteFormTextModule { }
